import React from "react";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { useTranslation } from 'react-i18next';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

/**
 * @Description this page Active Directory  Library's Delete Contact Action configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
export default function DeleteObject({
    action,
    variables,
    setOpenVariable,
}) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.';

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'DISTINGUISH-NAME')} is_required />
                <TextInput action={action} inputName="distinquishName"
                    variables={variables} setOpenVariable={setOpenVariable}
                    isRequired fieldType={"string"} displayName={t(label + 'DISTINGUISH-NAME')} hideRequired />
            </div>
        </div>
    );
}
